import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './video-carousel-item.component.scss';
import * as $ from 'jquery';
import axios from 'axios';
var VideoCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCarouselItem, _super);
    function VideoCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    VideoCarouselItem.prototype.init = function () {
        this.playButton = this.element.querySelector('.js-video-play');
        this.closeButton = this.element.querySelector('.js-video-close');
        this.playerContainer = this.element.querySelector('.video-carousel-item__container');
        this.playerContent = this.element.querySelector('.video-carousel-item__playercontent');
        this.playerTimeContainer = this.element.querySelector('.video-carousel-item__time-placeholder');
        this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
        this.video = this.element.querySelector('video');
        this.isExternal = false;
        this.checkResponsiveImage();
        this.createAnalyticsClick();
    };
    VideoCarouselItem.prototype.bindEvents = function () {
        var _this = this;
        this.playButton.addEventListener('click', function (event) { return _this.showVideo(event); });
        this.closeButton.addEventListener('click', function (event) { return _this.hideVideo(event); });
        this.renderTime();
    };
    VideoCarouselItem.prototype.showVideo = function (event) {
        event.preventDefault;
        this.hideActiveVideo(event);
        this.playerContainer.classList.add('video-carousel-item__container--playing');
        if (event.currentTarget.hasAttribute('data-youtube-id')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            var getVideo = videoExternal.getAttribute('data-youtube-id');
            this.createIframePlayer(getVideo);
            this.analyticsService.dtmVideoTrackerAutoSpot();
        }
        else if (event.currentTarget.hasAttribute('data-video-file')) {
            this.isExternal = true;
            var videoExternal = event.currentTarget;
            var getVideo = videoExternal.getAttribute('data-video-file');
            this.createHTML5Player(getVideo);
        }
        else {
            this.video.player.play();
        }
    };
    VideoCarouselItem.prototype.hideVideo = function (event) {
        event.preventDefault;
        var removeIframe = this.playerContent.querySelector('iframe');
        this.playerContainer.classList.remove('video-carousel-item__container--playing');
        if (removeIframe) {
            this.playerContent.removeChild(removeIframe);
        }
        else {
            this.video.player.pause();
        }
    };
    VideoCarouselItem.prototype.hideActiveVideo = function (event) {
        var selectedVideo = event.target;
        if (!selectedVideo.classList.contains('video-carousel-item__container--playing')) {
            var videoContainers = Array.from(document.querySelectorAll('.video-carousel-item__container--playing'));
            videoContainers.map(function (itemContainer) {
                itemContainer.classList.remove('video-carousel-item__container--playing');
                var iframeExistence = itemContainer.querySelector('iframe');
                if (iframeExistence) {
                    var iframeChildren = $(itemContainer).find('iframe');
                    iframeChildren.remove();
                }
                else {
                    var videoChildren = itemContainer.querySelector('video');
                    var playerChildren = itemContainer.querySelector('.ot-video-containingBlock');
                    videoChildren.pause();
                }
            });
        }
    };
    VideoCarouselItem.prototype.createIframePlayer = function (url) {
        var externalUrl = 'https://www.youtube.com/embed/';
        externalUrl += url;
        externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.classList.add('video__iframe');
        createIframe.setAttribute('allowfullscreen', 'true');
        this.playerContent.appendChild(createIframe);
    };
    VideoCarouselItem.prototype.createHTML5Player = function (url) {
        var externalUrl = url;
        var createIframe = document.createElement('iframe');
        createIframe.id = 'video__external';
        createIframe.src = externalUrl;
        createIframe.setAttribute('allowfullscreen', 'true');
        createIframe.classList.add('video__iframe');
        this.playerContent.appendChild(createIframe);
    };
    VideoCarouselItem.prototype.checkResponsiveImage = function () {
        // https://tribeca.vidavee.com/publish/rest/file/GetFileCurrentDefaultThumbnail/ECF973E4C05653AA1D16FA0134860E3D/thumbnail.jpg
        // https://img.youtube.com/vi/<insert-youtube-video-id-here>/0.jpg
        // let component = this.element.querySelector('.js-anchor');
        // let picture = component.querySelector('picture');
        // let responsiveImage = picture.querySelector('.responsive-image');
        // let attribute = responsiveImage.getAttribute('src');
        // if(attribute === null || attribute === "" || attribute === undefined){
        // 	if(this.playButton.hasAttribute('data-youtube-id')){
        // 		this.createResponsiveImage(component, true, this.playButton.getAttribute('data-youtube-id'));
        // 	}else if(this.playButton.hasAttribute('data-vidavee-id')){
        // 		this.createResponsiveImage(component, false, this.playButton.getAttribute('data-vidavee-id'));
        // 	}
        // }else{
        // 	console.log('has image');
        // }
    };
    VideoCarouselItem.prototype.createResponsiveImage = function (anchor, youtube, id) {
        if (youtube === void 0) { youtube = false; }
        if (id === void 0) { id = ""; }
        if (youtube) {
            var string = "<picture>\n\t\t\t\t<source srcset=\"https://img.youtube.com/vi/" + id + "/0.jpg\" media=\"(min-width: 1024px)\">\n\t\t\t\t<source srcset=\"https://img.youtube.com/vi/" + id + "/0.jpg\" media=\"(min-width: 768px)\">\n\t\t\t\t<img class=\"responsive-image \" src=\"https://img.youtube.com/vi/" + id + "/0.jpg\" srcset=\"https://img.youtube.com/vi/" + id + "/0.jpg\" alt=\"\">\n\t\t\t</picture>";
            anchor.innerHTML = string;
        }
        else {
            var string = "<picture>\n\t\t\t\t<source srcset=\"https://tribeca.vidavee.com/publish/rest/file/GetFileCurrentDefaultThumbnail/" + id + "/thumbnail.jpg\" media=\"(min-width: 1024px)\">\n\t\t\t\t<source srcset=\"https://tribeca.vidavee.com/publish/rest/file/GetFileCurrentDefaultThumbnail/" + id + "/thumbnail.jpg\" media=\"(min-width: 768px)\">\n\t\t\t\t<img class=\"responsive-image \" src=\"https://tribeca.vidavee.com/publish/rest/file/GetFileCurrentDefaultThumbnail/" + id + "/thumbnail.jpg\" srcset=\"https://tribeca.vidavee.com/publish/rest/file/GetFileCurrentDefaultThumbnail/" + id + "/thumbnail.jpg\" alt=\"\">\n\t\t\t</picture>";
            anchor.innerHTML = string;
        }
    };
    VideoCarouselItem.prototype.renderTime = function () {
        if (this.playButton.hasAttribute('data-youtube-id')) {
            var videoTimePlaceholder_1 = this.playerTimeContainer;
            var getVideo = this.playButton.getAttribute('data-youtube-id');
            axios.get('https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=' + getVideo + '&key=AIzaSyBcaoVc-sCwi_7txKMV9BEUhDf4yrcq384', { responseType: 'json' }).then(function (response) {
                var object = response.data.items[0].contentDetails.duration;
                var array = object.match(/(\d+)(?=[MHS])/ig) || [];
                var formatted = array.map(function (item) {
                    if (item.length < 2)
                        return '0' + item;
                    return item;
                }).join(':');
                if (formatted) {
                    videoTimePlaceholder_1.innerHTML = formatted;
                }
                else {
                    videoTimePlaceholder_1.innerHTML = '00:00:00';
                }
            }).catch(function (response) {
                console.log(response);
            });
        }
    };
    VideoCarouselItem.prototype.createAnalyticsClick = function () {
        var _this = this;
        var anchors = Array.from(this.element.querySelectorAll('.js-anchor'));
        anchors.map(function (item) {
            if (item.closest('.video-carousel-item__image-holder')) {
                var videoId = '';
                var closest = item.closest('.video-carousel-item__image-holder');
                if (closest.querySelector('.js-video-play')) {
                    var jsVideoPlay = closest.querySelector('.js-video-play');
                    if (jsVideoPlay.getAttribute('data-youtube-id')) {
                        videoId = jsVideoPlay.getAttribute('data-youtube-id');
                        item.classList.add('js-video-play');
                        item.setAttribute('data-youtube-id', videoId);
                    }
                    if (jsVideoPlay.getAttribute('data-video-file')) {
                        videoId = jsVideoPlay.getAttribute('data-video-file');
                        item.classList.add('js-video-play');
                        item.setAttribute('data-video-file', videoId);
                    }
                }
                var createDiv = document.createElement('div');
                createDiv.classList.add('video-carousel-item__image-holder--picture');
                createDiv.innerHTML = item.innerHTML;
                closest.appendChild(createDiv);
                item.classList.add('js-video-play');
                item.classList.add('overlay');
                item.innerHTML = '';
                item.addEventListener('click', function (event) {
                    _this.showVideo(event);
                });
            }
        });
    };
    return VideoCarouselItem;
}(Base));
export { VideoCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/video-carousel-item/video-carousel-item.component.ts
// module id = 557
// module chunks = 0